import React, { useState } from "react";
import {
    Box,
    Paper,
    TextField,
    Button,
    Typography,
    Alert,
    CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import API_URL from "../settings";
import { useAuth } from "../context/AuthContext";
import Logo1 from '../assets/Logo1.png';
import Logo2 from '../assets/Logo2.png';

function Login() {
    const navigate = useNavigate();
    const { login } = useAuth();

    const [form, setForm] = useState({
        username: "",
        password: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await fetch(
                `${API_URL}/users?username=${form.username}&password=${form.password}`
            );
            const data = await res.json();

            if (!data || data.length === 0) {
                throw new Error("ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง");
            }

            if (data[0].active === false) {
                throw new Error("บัญชีของคุณถูกระงับการใช้งาน");
            }

            // login success
            login(data[0]);
            navigate("/");
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f4f6f8",
            }}
        >
            <Paper
                elevation={4}
                sx={{
                    width: 420,
                    p: 4,
                    borderRadius: 3,
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    sx={{ mb: 3, fontWeight: "bold" }}
                >
                    ระบบสุขภาพชุมชน
                </Typography>


                <Typography
                    variant="body2"
                    align="center"
                    sx={{ mb: 3, color: "text.secondary" }}
                >
                    กรุณาเข้าสู่ระบบเพื่อใช้งาน
                </Typography>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Box component="form" onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label="ชื่อผู้ใช้"
                        name="username"
                        value={form.username}
                        onChange={handleChange}
                        margin="normal"
                        required
                    />

                    <TextField
                        fullWidth
                        label="รหัสผ่าน"
                        name="password"
                        type="password"
                        value={form.password}
                        onChange={handleChange}
                        margin="normal"
                        required
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        size="large"
                        sx={{ mt: 3 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : "เข้าสู่ระบบ"}
                    </Button>
                </Box>



                {/* demo accounts (เอาออกได้ตอนส่งจริง) */}
                <Box sx={{ mt: 3 }}>
                    {/* <Typography variant="caption" color="text.secondary">
                        ตัวอย่างบัญชี:
                    </Typography>
                    <Typography variant="caption" display="block">
                        เจ้าหน้าที่ อบต. :
                        admin / 1234
                    </Typography>
                    <Typography variant="caption" display="block">
                        โรงพยาบาลส่งเสริมสุขภาพตำบล :
                        officer01 / 1234
                    </Typography>
                    <Typography variant="caption" display="block">
                        อสม.ฐาปณีย์ :
                        vol01 / 1234
                    </Typography>
                    <Typography variant="caption" display="block">
                        อสม.นารีรัตน์  :
                        vol02 / 1234
                    </Typography> */}
                    {/* <Typography variant="caption" display="block">
                        สปสช. :
                        nhso / 1234
                    </Typography> */}
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        p: 1.5,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 1.5,
                    }}
                >

                    <Box
                        component="img"
                        src={Logo1}
                        alt="logo-1"
                        sx={{
                            height: 80,
                            maxWidth: '100%',
                            objectFit: 'contain',
                            opacity: 0.7,
                            transition: '0.2s',
                        }}
                    />
                    <Box
                        component="img"
                        src={Logo2}
                        alt="logo-2"
                        sx={{
                            height: 80,
                            maxWidth: '100%',
                            objectFit: 'contain',
                            opacity: 0.7,
                            transition: '0.2s',
                        }}
                    />
                </Box>

            </Paper>
        </Box>
    );
}

export default Login;
